import dashboard from './dashboard'
import informes from './informes'
import mantenimiento from './mantenimiento'
import transacciones from './transacciones'
// eslint-disable-next-line sort-imports
import { permissionTree, RESOURCE_MANTENIMIENTO } from '@/auth/permissions/modules/mantenimientoMaquinariaPg'
import { defineMenu } from '@/utils/menu'

export default defineMenu([
    {
        title: 'manprog.menu_title',
        fontIcon: 'toolbox',
        resource: RESOURCE_MANTENIMIENTO,
        action: permissionTree._root,
        children: [
            {
                title: 'global.menu.dashboard',
                icon: 'EditIcon',
                resource: RESOURCE_MANTENIMIENTO,
                action: permissionTree.dashboard._perm,
                children: dashboard,
            },
            {
                title: 'global.menu.mantenimiento',
                icon: 'EditIcon',
                resource: RESOURCE_MANTENIMIENTO,
                action: permissionTree.mantenimiento._perm,
                children: mantenimiento,
            },
            // {
            //     title: 'global.menu.configuracion',
            //     icon: 'SettingsIcon',
            //     resource: RESOURCE_MANTENIMIENTO,
            //     action: permissionTree.configuracion._perm,
            //     children: configuracion,
            // },
            {
                title: 'global.menu.transacciones',
                fontIcon: 'exchange-alt',
                resource: RESOURCE_MANTENIMIENTO,
                action: permissionTree.transacciones._perm,
                children: transacciones,
            },
            {
                title: 'global.menu.informes',
                fontIcon: 'file-prescription',
                resource: RESOURCE_MANTENIMIENTO,
                action: permissionTree.informes._perm,
                children: informes,
            },
        ],
    },
])
